
// Fix: Use compat imports to resolve missing named export errors in this environment
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const getEnvVar = (key: string): string | undefined => {
  const meta = import.meta as any;
  const env = meta.env || {};
  const processEnv = typeof process !== 'undefined' ? (process as any).env : {};
  return env[key] || processEnv[key];
};

const firebaseConfig = {
  apiKey: getEnvVar('VITE_FIREBASE_API_KEY') || "AIzaSyDBSyRKrSww2-X0wAh2RxMaJioZYBFblls",
  authDomain: getEnvVar('VITE_FIREBASE_AUTH_DOMAIN') || "omnivewlabs.firebaseapp.com",
  projectId: getEnvVar('VITE_FIREBASE_PROJECT_ID') || "omnivewlabs",
  storageBucket: getEnvVar('VITE_FIREBASE_STORAGE_BUCKET') || "omnivewlabs.firebasestorage.app",
  messagingSenderId: getEnvVar('VITE_FIREBASE_MESSAGING_SENDER_ID') || "956320267825",
  appId: getEnvVar('VITE_FIREBASE_APP_ID') || "1:956320267825:web:8e1146b9efb1fc9352df10"
};

// Use singleton pattern for app initialization using compat API
const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();

// Exporting instances using the compat API to ensure compatibility with the environment
export const auth = firebase.auth();
export const db = firebase.firestore();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export default app;
